import { Component, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { TranslationPipe } from '@raptor-fe/services';
import { LaunchFailure } from './launch.constants';
import { LaunchStore } from './store/launch.store';

/**
 * Landing page for the Marlin Blue Workshop Dashboard. The federation launch endpoint redirects here
 * with either a one-time launch code to exchange or the reason it could not issue one.
 */
@Component({
    selector: 'lib-launch',
    imports: [TranslationPipe],
    templateUrl: './launch.component.html',
    providers: [LaunchStore],
})
export class LaunchComponent {
    protected readonly store = inject(LaunchStore);

    protected readonly LaunchFailure = LaunchFailure;

    private readonly activatedRoute = inject(ActivatedRoute);

    constructor() {
        this.activatedRoute.queryParams.pipe(takeUntilDestroyed()).subscribe((params) => {
            void this.store.launch(params);
        });
    }
}
